/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
// Importing components
import AccountLogin from "./AccountLogin/AccountLogin";
import ForgotPasswordForm from "./ForgotPasswordForm/ForgotPasswordForm";
// Import hooks
import gaEvents from "../../../hooks/gaEvents";
import pixelEvent from "../../../hooks/pixelEvent";
// Importing styles and images
import style from "./Login.module.sass";
import userIcon from "../../../assets/images/login/userIcon.svg";
import ModalWindow from "../../../components/UI/ModalWindow/ModalWindow";

function Login() {
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [filedTouch, setFiledTouch] = useState({
    email: false,
    password: false,
  });
  const [emailError, setEmailError] = useState("Field is required");
  const [passwordError, setPasswordError] = useState("Field is required");

  const [isForgotPassword, setIsForgotPassword] = useState(
    params.get("forgot")
  );
  const [isForgotPasswordSuccess, setIsForgotPasswordSuccess] = useState(false);
  const [timer, setTimer] = useState({ min: 0, sec: 0 });

  useEffect(() => {
    if (isForgotPasswordSuccess) {
      const timeoutId = setTimeout(() => {
        setIsForgotPassword(false);
        setIsForgotPasswordSuccess(false);
        history.replace("/login");
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [isForgotPasswordSuccess]);

  const emailHandler = (e) => {
    setEmail(e.target.value);
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(e.target.value).toLowerCase())) {
      setEmailError("Invalid email");
    } else {
      setEmailError("");
    }
  };

  const passwordHandler = (e) => {
    setPassword(e.target.value);
    if (e.target.value === "") {
      setPasswordError("Field is required");
    } else {
      setPasswordError("");
    }
  };

  const onBlurHandler = (e) => {
    setFiledTouch({ ...filedTouch, [e.target.name]: true });
  };
  const handleForgotPasswordClick = () => {
    setIsForgotPassword(true);
    gaEvents.forgotPassword();
    pixelEvent({
      evt_src: "acct",
      evt_action: "forgot_pwd_click",
    });
  };

  const setTimerFormatted = (min, sec) => {
    setTimer({
      min: String(min).padStart(2, "0"),
      sec: String(sec).padStart(2, "0"),
    });
  };

  const startTimer = () => {
    let min = 3;
    let sec = 0;

    setTimerFormatted(min, sec);

    const timer = setInterval(() => {
      if (sec === 0) {
        if (min === 0) {
          clearInterval(timer);
          return;
        }
        min--;
        sec = 59;
      } else {
        sec--;
      }
      setTimerFormatted(min, sec);
    }, 1000);
  };

  return (
    <div className={style.loginWrapper}>
      <div className={style.header}>
        <img className={style.userIcon} src={userIcon} alt="" />
        <div className={style.title}>Login to My Account</div>
      </div>
      <div className={style.loginFormWrapper}>
        <ModalWindow
          title="Forgot your password?"
          onCancel={() => setIsForgotPassword(false)}
          isOpen={isForgotPassword}
        >
          <ForgotPasswordForm
            emailHandler={emailHandler}
            onBlurHandler={onBlurHandler}
            setIsForgotPasswordSuccess={() => setIsForgotPasswordSuccess(true)}
            timer={timer}
            startTimer={startTimer}
          />
        </ModalWindow>

        <AccountLogin
          email={email}
          emailTouch={filedTouch.email}
          emailHandler={emailHandler}
          emailError={emailError}
          password={password}
          passwordTouch={filedTouch.password}
          passwordHandler={passwordHandler}
          passwordError={passwordError}
          onBlurHandler={onBlurHandler}
        />

        <button
          onClick={handleForgotPasswordClick}
          className={style.forgotPassword}
        >
          I forgot my password
        </button>
        <div className={style.createNewAccount}>
          <span>Not a member yet? </span>
          <a
            href="/?p=acct_r1_black"
            onClick={() => {
              gaEvents.newAccount();
            }}
          >
            Create a New Account
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
